import { STORE_SET } from "../contants/constants";
import { getStoreData } from "../../services/store"; // adjust path if needed

const initialState = {
  basket: [],
  store: [],
  loading: false,
  error: null,
};

export const fetchAndSetStore = () => async (dispatch, getState) => {
  const { store } = getState().store;
  if (store && store.length > 0) return; // Already loaded, do nothing

  dispatch({ type: "STORE_LOADING" });
  try {
    const data = await getStoreData();
    dispatch({ type: STORE_SET, store: data });
  } catch (error) {
    dispatch({ type: "STORE_ERROR", error: error.message });
  }
};

export const store = (state = initialState, action) => {
  switch (action.type) {
    case "STORE_LOADING":
      return { ...state, loading: true, error: null };
    case STORE_SET:
      return { ...state, store: action.store, loading: false, error: null };
    case "STORE_ERROR":
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};
